import React, { useEffect, useId } from 'react'

import Button from '../Button/Button'

export const Popup = (props) => {
  const {
    heading,
    subheading,
    copy = [],
    image = {},
    buttonText,
    buttonIcon,
    onClose,
    showModal,
  } = props

  const headingId = useId()

  useEffect(() => {
    if (!showModal) return undefined

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose()
      }
    }

    document.addEventListener('keydown', onKeyDown)
    document.body.style.overflow = 'hidden'

    return () => {
      document.removeEventListener('keydown', onKeyDown)
      document.body.style.overflow = ''
    }
  }, [showModal, onClose])

  if (!showModal) {
    return null
  }

  return (
    <div
      className="popup popup-visible"
      role="dialog"
      aria-modal="true"
      aria-labelledby={headingId}
      onClick={onClose}
    >
      <div
        className="popup__content"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="popup__close"
          onClick={onClose}
          aria-label="Close dialog"
        >
          <span aria-hidden="true">×</span>
        </button>
        <h2 id={headingId}>{heading}</h2>
        {subheading && (
          <h3 className="popup__subheading">{subheading}</h3>
        )}
        {image?.src && (
          <img src={image.src} alt={image.alt || ''} />
        )}
        {copy?.length > 0 && (
          <div className="popup__text-container">
            {copy.map((paragraph, key) => (
              <p key={key} className="popup__text">{paragraph}</p>
            ))}
          </div>
        )}
        <div className="popup__button-container">
          <Button
            hasButtonIcon
            onClick={onClose}
            buttonText={buttonText}
            icon={buttonIcon}
          />
        </div>
      </div>
    </div>
  )
}

export default Popup
